import { FastField } from 'formik';
import React from 'react';
import PersonalError from './PersonalError';

const Input = (props) => {

    const {name,type,icon,formik, placeholder,direction} = props
    return (
        <div className="form-group icon-group position-relative">
        <FastField
          type={type}
          className="form-control"
          id={name}
          name={name}
          {...formik.getFieldProps(name)}
          placeholder={placeholder}
          dir={direction}
        />
        <span className="icon-inside">
          <i className={icon}></i>
        </span>
        <PersonalError
          errors={formik.errors}
          touched={formik.touched}
          name={name}
        />
      </div>
    );
}

export default Input;
